import { render, staticRenderFns } from "./zCentralizedToolbar.vue?vue&type=template&id=081f7fbe&scoped=true&"
import script from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"
export * from "./zCentralizedToolbar.vue?vue&type=script&lang=js&"
import style0 from "./zCentralizedToolbar.vue?vue&type=style&index=0&id=081f7fbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f7fbe",
  null
  
)

export default component.exports